//Auth
export const API_AUTH_LOGIN = '/auth/signin';

//Users
export const API_GET_ALL_USERS = '/users';
export const API_USERS_TOKEN = '/users/token';
export const API_GET_ALL_ROLE = '/users/role?system=' + process.env.REACT_APP_LOCALHOST_SYSTEM;
//Match
export const API_MATCH = '/match';
export const API_MATCH_WC_MATCHES = '/match/wc-matches';

export const API_MATCH_RESULT = '/match/update-matches';

//Predictions
export const API_PREDICTIONS = '/predictions';
export const API_PREDICTIONS_CHAMPION_TEAMS = '/worldcup/champion-predictions';
export const API_PREDICTIONS_TOP_SCORERS = '/worldcup/player-predictions';

//Settings
export const API_SETTINGS = '/settings';
export const API_SETTINGS_RANK = '/settings/update-rank';
export const API_SETTINGS_PRIZE_STRUCTURE = '/settings/update-prize-structure';
//Banner
export const API_BANNER = '/banner';
//Uploads
export const API_UPLOAD_IMAGE = '/upload/image';

export const API_TEAMS = '/worldcup/teams';
//Top Scorers (Players)
export const API_TOP_PLAYERS = '/worldcup/players';

export const API_GET_WORLDCUP_RESULTS = '/worldcup/get-worldcup-results';
export const API_UPDATE_WORLDCUP_RESULT = '/worldcup/update-worldcup-result';

// LiveScore APIs
export const API_GET_ALL_LEAGUE = '/get-league';
export const API_GET_MATCH_SCHEDULE = '/match-schedule';
export const API_GET_SCHEDULE_BY_LEAGUE = '/get-schedule';
